import React, { useCallback } from 'react';

import { inputsConfig, typeInput } from './config';
import './BeneficiaryInput.scss';

const BeneficiaryDisplayOnly = ({ beneficiary = {} }) => {
  const { entityType } = beneficiary;

  const extractOptionText = useCallback((value, options) => {
    const option = options.find((op) => op.value === value);
    return option ? option.label : '';
  }, []);
  return (
    <div className="Beneficiary --existing">
      <fieldset className={`Beneficiary_row ${entityType}`}>
        <div
          className={`Beneficiary_row-item -${typeInput.prop}`}
          style={{ order: 0 }}
          key={`type`}
        >
          <label htmlFor={typeInput.prop}>{typeInput.label}</label>
          <span>{extractOptionText(entityType, typeInput.options)}</span>
        </div>

        {inputsConfig[entityType].map((col, i) => (
          <div
            className={`Beneficiary_row-item -${col.prop}`}
            style={{ order: i + 1 }}
            key={`${col.prop}-${i}`}
          >
            <label htmlFor={col.prop}>{col.label}</label>
            <span>
              {beneficiary[col.prop]
                ? col.input === 'dropdown'
                  ? extractOptionText(beneficiary[col.prop], col.options)
                  : beneficiary[col.prop]
                : col.prop === 'firstName' &&
                  beneficiary.entity.entityName.firstName !== ''
                ? beneficiary.entity.entityName.firstName
                : col.prop === 'middleName' &&
                  beneficiary.entity.entityName.middleName !== ''
                ? beneficiary.entity.entityName.middleName
                : col.prop === 'lastName' &&
                  beneficiary.entity.entityName.lastName !== ''
                ? beneficiary.entity.entityName.lastName
                : col.prop === 'suffix' &&
                  beneficiary.entity.entityName.suffix !== ''
                ? beneficiary.entity.entityName.suffix
                : (col.prop === 'taxId' || col.prop === 'ssn') &&
                  beneficiary.entity?.entityKey?.taxID !== undefined &&
                  beneficiary.entity?.entityKey?.taxID !== null
                ? beneficiary.entity?.entityKey?.taxID
                : '--'}
              {col.input === 'percent' && '%'}
            </span>
          </div>
        ))}
      </fieldset>
    </div>
  );
};

export default BeneficiaryDisplayOnly;
